// extracted by mini-css-extract-plugin
export default {"container":"Product_container__60EbW","noSidebar":"Product_noSidebar__XTbQ3"};